import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { OrderService } from 'src/app/services/order/order.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';


@Component({
  selector: 'app-cancelledorders',
  templateUrl: './cancelledorders.component.html',
  styleUrls: ['./cancelledorders.component.css']
})
export class CancelledordersComponent implements OnInit {

  data: any;

  isUserAdmin: boolean;
  isUserVendor: boolean;
  isUserHr: boolean;

  constructor(private orderServices: OrderService, private router: Router, private userService: UserService) {


    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
      });

    this.userService.isUserVendor.subscribe(
      value => {
        this.isUserVendor = value;
      });

    this.userService.isUserHr.subscribe(
      value => {
        this.isUserHr = value;
      });

  }

  ngOnInit() {

    if (this.isUserAdmin) {
      this.getAllCancelledOrder();
    }
    if (this.isUserVendor) {
      this.getMyCancelledOrder();
    }
    if (this.isUserHr) {
      this.getAllCancelledOrder();
    }

  }

  getAllCancelledOrder() {
    this.orderServices.getAllCancelledOrder().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  getMyCancelledOrder() {
    this.orderServices.getMyCancelledOrder().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  ViewOrder(orderno: string) {
    if (orderno != null) {
      this.router.navigate(['/manageorder', orderno]);
    }
  }

}
